export function checkIfValidExt(url) {
  if (!url || url === "") return false;
  const lower = url.toLowerCase();
  return lower.includes('png') || lower.includes('svg') || lower.includes('webp');
}

export function getExt(fileName) {
  if (!fileName) return undefined;

  const fileNameToLower = fileName.toLowerCase();

  if (fileNameToLower.includes('png')) {
    return 'image/png'
  } else if (fileNameToLower.includes('webp')) {
    return 'image/webp'
  } else if (fileNameToLower.includes('svg')) {
    return 'image/svg+xml'
  } else {
    return undefined;
  }
}

export function checkIfCardPwa(cardInfos, folders) {
  if (!folders) return false;

  const folderSet = new Set(cardInfos?.folders);


  return Object.entries(folders).some(folder => {
    return (folderSet.has(folder[0]) && folder[1]?.pwa_enabled)
  });
}

export function getPwaEnabledFolders(folders) {
  let pwaEnabledFolders = [];

  if (!folders) return pwaEnabledFolders;

  pwaEnabledFolders = Object.entries(folders).filter(folder => folder[1]?.pwa_enabled);

  return pwaEnabledFolders;
}

export function extractPwaCards(cards, folders) {
  const folderIds = new Set(getPwaEnabledFolders(folders).map(([id]) => id))

  return (cards || []).filter(card =>
    card.folders?.some(folderId => folderIds.has(folderId))
  )
}

export function collectCardImageUrls(cardsData, themeInfos, widescreenData) {
  const urls = new Set()

  if (themeInfos) {
    if (themeInfos.details?.logo && themeInfos.details?.logo !== '') {
      urls.add(themeInfos.details?.logo)
    }
    if (themeInfos.details?.pastille && themeInfos.details?.pastille !== '') {
      urls.add(themeInfos.details?.pastille)
    }
  }

  if (widescreenData) {
    if (widescreenData.logo) {
      urls.add(widescreenData.logo)
    }
    if (widescreenData.backgroundImage) {
      urls.add(widescreenData.backgroundImage)
    }
  }

  if (cardsData) {
    cardsData.forEach(card => {
      card.parts.forEach(part => {
        switch (part.type) {
          case 'Picture':
          case 'PictureUrl':
            if (part.url) {
              urls.add(part.url)
            }
            break
          case 'Giphy':
            urls.add(part.url || part.gif)
            break
          case 'Panorama360':
            if (part.url) {
              urls.add(part.url)
            }
            break
          case 'BeforeAfter': {
            const before = part.before || part.beforeOriginal
            const after = part.after || part.afterOriginal
            if (before?.url) {
              urls.add(before.url)
            }
            if (after?.url) {
              urls.add(after.url)
            }
            break
          }
          case 'SlideShow':
            for (const slide of part.slides || []) {
              if (['Picture', 'Url', '360'].includes(slide.type) && slide.url) {
                urls.add(slide.url);
              }
            }
            break
          case 'Button':
            if (part.url) {
              urls.add(part.url);
            }
            break
          case 'Button-Half':
            if (part.url) {
              urls.add(part.url);
            }
            break
          case 'ButtonFileUpload':
            if (part.url) {
              urls.add(part.url);
            }
            if (part.buttonImageUrl) {
              urls.add(part.buttonImageUrl);
            }
            break
          case 'Audio':
            if (part.url) {
              urls.add(part.url);
            }
        }
      })
    })
  }

  urls.delete(undefined)
  return Array.from(urls)
}

export function collectRAImages(ra) {
  const urls = new Set()
  if (!ra) return []

  if (ra.calibrate?.image) urls.add(ra.calibrate.image)
  if (ra.welcome?.image) urls.add(ra.welcome.image)
  if (ra.watermark?.image) urls.add(ra.watermark.image)

  for (const instruction of ra.instructions || []) {
    if (instruction.image) urls.add(instruction.image)
  }
  for (const experience of ra.experiences || []) {
    if (experience.image) urls.add(experience.image)
  }

  if (ra.stickers?.use !== 'none') {
    for (const item of ra.stickers?.items || []) {
      if (item) urls.add(item)
    }
    if (ra.stickers?.framePortrait) urls.add(ra.stickers.framePortrait)
    if (ra.stickers?.frameLandscape) urls.add(ra.stickers.frameLandscape)
  }

  urls.delete(undefined)
  return Array.from(urls)
}
